var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { "--varBg": _vm.varBg }, attrs: { id: "clock" } },
    [
      _c("p", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
      _vm.time
        ? _c(
            "p",
            {
              staticClass: "time",
              style: {
                fontSize: parseInt(_vm.element.style.fontSize) * 3 + "px",
              },
            },
            [_vm._v(_vm._s(_vm.time))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }